import { WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const warrantyLogByIdQueryKey = 'warrantyLogByIdQueryKey';

export const useWarrantyLogByIdQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: { id: number },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLog1>>,
      QueryError,
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLog1>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [warrantyLogByIdQueryKey, ...(queryKey ?? [{ ...input }])],
    () => WarrantyLogService.getWarrantyLog1(input.id),
    options
  );
